import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const CardWrapper = styled.div`
  &:not(:last-of-type) {
    margin-bottom: 25px;
  }
`;

export const space = css`
  & > * {
    width: 100%;
  }

  ${mediaQuery('tablet', 'min')} {
    & > *:nth-of-type(1) {
      width: 25%;
      white-space: break-spaces;
    }

    & > *:nth-of-type(2) {
      width: calc(25% - 24px);
      margin: 0 12px;
    }

    & > *:nth-of-type(3) {
      width: calc(25% - 24px);
      margin: 0 12px;
    }

    & > *:nth-of-type(4) {
      text-align: left;
      width: calc(15% - 24px);
      margin: 0 12px;
      white-space: nowrap;
    }

    & > *:nth-of-type(5) {
      width: 10%;
      margin-right: 0;
    }
  }
`;

export const HeaderWrapper = styled.div`
  display: none;

  ${mediaQuery('tablet', 'min')} {
    display: flex;
    width: 100%;
    padding: 10px 25px;
    font-weight: 600;
    ${space};
  }
`;

export const CountWrapper = styled.div`
  display: inline-block;
  background: ${(props) => props.theme.color.blue.default};
  width: 24px;
  height: 24px;
  border-radius: 32px;
  margin-left: 8px;
  color: white;
  text-align: center;
  font-size: 12px;
  line-height: 24px;
  font-weight: 600;
`;

export const SuggestionWrapper = styled.div`
  margin-top: 36px;
`;
